module.exports = __webpack_public_path__ + "img/image-017.d3883843.png";